module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-indent": "17px"
    }
  }, [_c('em', [_vm._v("Contributors")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "50px"
    }
  }, [_vm._v("Nassim BARCHICHE. MD")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Consultant Radiologist")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Centre D’imagerie Médicale Dr. Lekhal M ")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Blida, Algeria")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "50px"
    }
  }, [_vm._v("Gamal HASSAN. MD, MRCP (UK)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Consultant Physician")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v(" Ohud Hospital")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v(" Medinah, KSA")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "50px"
    }
  }, [_vm._v("Chelia BOUKAABA. MD")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Consultant Radiologist")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Centre D’imagerie Médicale Aurès ")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Batna, Algeria")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "50px"
    }
  }, [_vm._v("Amine RAMDANI. MD")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Consultant Radiologist")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Centre D’imagerie Médicale Aurès Batna, Algeria")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "50px"
    }
  }, [_vm._v("Zine-eddine BOUDIAF. MD")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Consultant Radiologist")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v(" CHU Constantine, Algeria")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "50px"
    }
  }, [_vm._v("Fouzi BALA. MD")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Consultant Interventional Neuro-radiologist ")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Roger Salengro Hospital")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Lille, France")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "50px"
    }
  }, [_vm._v("Shahid HUSSEIN. MD ")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v("Consultant Radiologist")]), _c('p', {
    staticStyle: {
      "text-indent": "80px"
    }
  }, [_vm._v(" Ohud Hospital Medinah, KSA")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0